import React, { useEffect } from 'react';

import Suspense from '../framework/suspense';
import useTranslation from '../../hooks/use_translation';

const Widget = (props) => {
	const { language } = useTranslation('component_script_trustpilot');

	useEffect(() => {
		if (
			typeof window !== 'undefined' &&
			window?.Klarna?.OnsiteMessaging?.refresh
		) {
			window.Klarna.OnsiteMessaging.refresh();
		}
	}, []);

	return (
		<klarna-placement
			data-locale={language == 'en' ? 'en-SE' : 'sv-SE'}
			{...props}
		></klarna-placement>
	);
};

const Klarna = (props) => {
	return (
		<Suspense>
			<Widget {...props} />
		</Suspense>
	);
};

export default Klarna;
